import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a70c7b34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-content-block-wrap" }
const _hoisted_2 = { class: "news-content-block" }
const _hoisted_3 = { class: "news-content-block-title margin-l-r" }
const _hoisted_4 = { class: "news-content-block-sub-title" }
const _hoisted_5 = { class: "news-content-block-laters" }
const _hoisted_6 = { class: "news-content-block-footer-title margin-l-r" }

import {WrapTitle} from "@/entities";
import {useLocalizationStore} from "@/shared";
import {LatestNews} from "@/features";


export default /*#__PURE__*/_defineComponent({
  __name: 'news-content',
  props: {
  showSelectedNews: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;


const {translate} = useLocalizationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(WrapTitle), {
          text: _unref(translate)('keep_up_to_date'),
          class: "news-content-block-wrap-title",
          size: "regular",
          weight: "700"
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)("keep_up_to_date_sub_title")), 1)
      ], 512), [
        [_vShow, !__props.showSelectedNews]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(LatestNews), {
          showButton: false,
          showTitle: false,
          others: true
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(WrapTitle), {
          text: _unref(translate)('new_content'),
          size: "light",
          weight: "700"
        }, null, 8, ["text"])
      ])
    ])
  ]))
}
}

})